import './scenario-planner-cell-prod.component.scss';
import { DescriptorsComponent } from '../../../../components/descriptor/descriptor.component';
import { CellProps } from '../../../../components/reports/generic-table/cell-prod.component';

export const ScenarioPlannerCellProdComponent = ({ data }: CellProps) => {
  const value = data.metadata ? data.metadata.description : '';

  return (
    <div className="scenario-planner-prod-cell-text">
      <div className="d-block">
        <div>{value}</div>
        <DescriptorsComponent metadata={data?.metadata} />
      </div>
    </div>
  );
};
